import { forwardRef } from "react";
import { Switch, SwitchProps, FormControl, BoxProps } from "@chakra-ui/react";

export type KYDSwitchProps = SwitchProps & {
  label?: string;
  description?: string;
  containerStyle?: BoxProps;
  error?: string;
};

const KYDSwitch = forwardRef<HTMLInputElement, KYDSwitchProps>(
  ({ name, label, description, error, containerStyle, sx, ...props }, ref) => {
    return (
      <Switch
        ref={ref}
        id={name}
        name={name}
        sx={{
          "& .chakra-switch__thumb::after": {
            content: "''",
          },
          "&[data-checked] .chakra-switch__thumb::after": {
            content: "'✔'",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            fontSize: "14px",
            fontWeight: "bold",
          },
          ...sx,
        }}
        {...props}
      />
    );
  }
);

KYDSwitch.displayName = "KYDSwitch";

export default KYDSwitch;
